<div
    class="student-details-container"
    *ngIf="!showStudentUpdate && student"
    fxFlex="50%"
    fxFlex.sm="75%"
    fxFlex.xs="auto"
>
    <form [formGroup]="shareDetailsForm">
        <div class="default student-information">
            <h1 class="page-title mb-1">
                Hello
                <span class="text-highlight">{{
                    student.personalDetails.firstName
                }}</span>
            </h1>
            <hr />
            <div class="row">
                <h2 class="page-subtitle">
                    Your Australian Tertiary Admission Rank
                </h2>
            </div>

            <table class="mt-0" mat-table [dataSource]="studentDataDetails">
                <ng-container matColumnDef="exitYear">
                    <th mat-header-cell *matHeaderCellDef>Graduating Year</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.exitYear }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="dateOfIssue">
                    <th mat-header-cell *matHeaderCellDef>Date of Issue</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.issueDate }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="atarData">
                    <th mat-header-cell *matHeaderCellDef>ATAR</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.atarScore }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="noRecord">
                    <td mat-footer-cell *matFooterCellDef>No Results Found</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTable1"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsTable1"></tr>
                <ng-template [ngIf]="studentDataDetails.length == 0">
                    <tr mat-footer-row *matFooterRowDef="['noRecord']"></tr>
                </ng-template>
            </table>
          <div *ngIf="showInfo" class="info-container">
            <mat-icon class="info-icon">info</mat-icon>
            <span class="info-text">
              To purchase a printed ATAR certificate, please fill out the form under ATAR Verification on the
              <a href="https://www.qtac.edu.au/atar-portal-useraccess-verification-stripe/" target="_blank" class = "text-link">QTAC website.</a>
            </span>
          </div>
            <div class="send-email-section-card mb-1">
                <div class="row pb-1">
                    <mat-checkbox
                        name="sendEmail"
                        data-test="send-email-checkbox"
                        formControlName="sendEmail"
                        class="opt-in-share-checkbox col col-6"
                        (change)="sendEmailChanged()"
                        >I want to receive an email notifying me that my ATAR result has been released.
                    </mat-checkbox>
                </div>
            </div>
            <hr />
        </div>
        <div class="default student-information">
          <div class="row">
            <h2 class="page-subtitle col">Your Details</h2>
            <button *ngIf="allowEditDetails()"
              mat-raised-button
              class="dashboard-button mb-1 col"
              data-test="dashboard-button-edit-details"
              (click)="editDetails()"
              type="button"
            >
              Edit Your Details
            </button>
          </div>
            <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayoutGap="15%"
                fxLayoutGap.xs="0%"
            >
                <div>
                    <div class="student-detail-item">
                        <div class="student-detail-title">Name</div>
                        <br />
                        <span data-test="student-info-name">
                            {{ student.personalDetails.firstName }}
                            {{ student.personalDetails.lastName }}
                        </span>
                    </div>
                    <div class="student-detail-item">
                        <div class="student-detail-title">Date of Birth</div>
                        <br />
                        <span data-test="student-info-dob">{{
                            getFormat(student.personalDetails.dateOfBirth)
                        }}</span>
                    </div>
                </div>
                <div>
                    <div class="student-detail-item">
                        <div class="student-detail-title">LUI</div>
                        <br />
                        <span data-test="student-info-lui">{{
                            student.personalDetails.lui
                        }}</span>
                    </div>
                    <div class="student-detail-item">
                        <div class="student-detail-title">Phone</div>
                        <br />
                        <span data-test="student-info-phone">
                            {{ student.personalDetails.phone }}
                        </span>
                    </div>
                </div>
            </div>
            <p>
                If your details are incorrect, you may not be matched correctly with
                your QCAA student data or ATAR results.
            </p>
            <div class="row" fxLayoutAlign="space-between">
                <div class="student-detail-item">
                    <div class="student-detail-title">Email</div>
                    <br />
                    <span data-test="student-info-email">
                        {{ student.personalDetails.email }}
                    </span>
                </div>
                <button *ngIf="allowEditEmail()"
                        mat-raised-button
                        class="dashboard-button mb-1 col"
                        data-test="dashboard-button-edit-email"
                        (click)="editEmail()"
                        type="button"
                >
                    Edit Email
                </button>
            </div>
            <hr />
        </div>
        <div class="default student-information">
            <div class="row">
                <h2 class="page-subtitle col col-6 mt-0">Your Data</h2>
            </div>

            <table class="mt-0" mat-table [dataSource]="studentDataDetails">
                <ng-container matColumnDef="exitYear">
                    <th mat-header-cell *matHeaderCellDef>Exit Year</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.exitYear }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="qcaaData">
                    <th mat-header-cell *matHeaderCellDef>QCAA Data</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.qcaaData }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="atarData">
                    <th mat-header-cell *matHeaderCellDef>ATAR Data</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.atarData }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="noRecord">
                    <td mat-footer-cell *matFooterCellDef>No Match Found</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsTable2"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsTable2"
                ></tr>
                <ng-template [ngIf]="studentDataDetails.length == 0">
                    <tr mat-footer-row *matFooterRowDef="['noRecord']"></tr>
                </ng-template>
            </table>
            <p>
                When your account cannot be matched to both QCAA or ATAR data
                you will be unable to receive your ATAR for your graduating
                year. If you have no matches on QCAA or ATAR data and the data
                has been released please
                <a data-test="data-help-link"
                   class="text-link"
                   href="https://www.qtac.edu.au/about-us/contact-us/email-enquiry-form"
                   target="_blank"
                   title="QTAC - Contact Us"
                >contact us.</a>
            </p>
            <div class="opt-in-section-card">
                <h3 class="row"><strong>Data Privacy</strong></h3>
                <div class="row">Optional consent (please tick the box if you do not consent)</div>
                <div class="row pb-1">
                    <mat-checkbox
                        name="optIn"
                        data-test="opt-in-share-checkbox"
                        formControlName="optIn"
                        class="opt-in-share-checkbox col col-6"
                        (change)="shareDetailsChanged()"
                        >I do not consent to my ATAR or ATAR eligibility as determined by QTAC being shared
                      with the school I attended in year 12.
                    </mat-checkbox>
                </div>
                <div class="row disclaimer-text">
                Disclaimer: QTAC discloses individual ATARs and ATAR eligibility, as calculated by QTAC,
                  to the school you attended in year 12.
                  If you do not consent to QTAC disclosing your individual ATAR or ATAR eligibility to the school
                  you attended in year 12, please opt out by selecting the tick box.
                  If you do not opt out, the school you attended in year 12 will be provided with your individual
                  ATAR or ATAR eligibility. Irrespective of whether you opt out, your ATAR will form part of any
                  aggregated (de-identified) ATAR results that may be provided to your school.
                  If you do not opt out when creating either your ATAR account or your QTAC application and
                  later wish to exercise your option to opt-out, you may change your option in the ATAR portal
                  on the ‘Your Details’ page, or use the ‘Manage Account’ option in the QTAC Application portal.
                  <a class="text-link"
                     target="_blank"
                     href="https://www.qtac.edu.au/privacy-and-legal/">
                    QTAC Customer Declaration
                  </a>
                </div>
            </div>
        </div>
    </form>
</div>

<ng-template #noMatchDialog>
    <h3 matDialogTitle class="mb-05">No Match Found</h3>
    <div mat-dialog-content class="mb-1">
        Your LUI, Names or Date of Birth provided have not been matched to a QCAA student record.<br/>
        Please check that you have entered your personal information correctly.<br/><br/>
        View this
        <a class="text-link"
           target="_blank"
           href="https://www.qtac.edu.au/atar/">
           link
        </a>
        for more information on matching your ATAR and QCAA Learning Account details.
    </div>
    <div mat-dialog-actions>
        <span fxFlex></span>
        <button class="mb-0"
                type="button"
                mat-button
                mat-dialog-close="true">
            Close
        </button>
    </div>
</ng-template>

<app-student-update
    *ngIf="showStudentUpdate"
    (toggleShowStudentUpdateOutput)="setShowStudentUpdate($event)"
></app-student-update>
